import React from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { HeartPulseIcon } from 'lucide-react';
export function OffersHealthWellness() {
  const products = [{
    id: 1,
    name: 'Multivitamin Complex',
    brand: 'CENTRUM',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.8,
    reviewCount: 156,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    expressDelivery: true
  }, {
    id: 2,
    name: 'Omega-3 Fish Oil',
    brand: 'NATURE MADE',
    price: 15.99,
    originalPrice: 24.99,
    discount: 36,
    rating: 4.7,
    reviewCount: 128,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
    expressDelivery: true
  }, {
    id: 3,
    name: 'Vitamin D3 + K2',
    brand: 'GARDEN OF LIFE',
    price: 12.99,
    originalPrice: 18.99,
    discount: 32,
    rating: 4.9,
    reviewCount: 87,
    image: 'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
    expressDelivery: true
  }, {
    id: 4,
    name: 'Magnesium Citrate',
    brand: 'NOW FOODS',
    price: 14.99,
    originalPrice: 21.99,
    discount: 32,
    rating: 4.6,
    reviewCount: 92,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
    expressDelivery: true
  }, {
    id: 5,
    name: 'Zinc + Vitamin C',
    brand: 'SOLGAR',
    price: 11.99,
    originalPrice: 17.99,
    discount: 33,
    rating: 4.7,
    reviewCount: 76,
    image: 'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
    expressDelivery: true
  }, {
    id: 6,
    name: 'Probiotics Complex',
    brand: 'CULTURELLE',
    price: 22.99,
    originalPrice: 34.99,
    discount: 34,
    rating: 4.8,
    reviewCount: 104,
    image: 'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    expressDelivery: true
  }];
  return <div className="container mx-auto px-4 py-6" data-id="element-4947" data-mp="3us6d5sjja0rn">
      <div className="rounded-t-xl bg-brand p-4 md:p-6" data-id="element-4948" data-mp="cj5t7ye0vjd5">
        <div className="flex items-center justify-between" data-id="element-4949" data-mp="7l4c3j05pu4b">
          <div className="flex items-center text-white" data-id="element-4950" data-mp="7lno6j34loaf">
            <div className="bg-white bg-opacity-20 p-2 rounded-full mr-3" data-id="element-4951" data-mp="3g0e8qbla274p">
              <HeartPulseIcon className="w-6 h-6" data-id="element-4952" data-mp="3b1uqal5w7dh3" />
            </div>
            <div data-id="element-4953" data-mp="3b3nuzuwy3nmg">
              <span className="rounded bg-white px-2 py-1 text-xs font-bold uppercase text-brand" data-id="element-4954" data-mp="3b0031075f99u">
                Health Products
              </span>
              <h2 className="text-2xl md:text-3xl font-bold mt-1" data-id="element-4955" data-mp="3kyza4ec9mwuq">
                Health & Wellness Essentials
              </h2>
              <p className="text-sm text-[#E4E8F2]" data-id="element-4956" data-mp="2x8d4sutnbqof">
                Premium supplements to support your daily wellness routine
              </p>
            </div>
          </div>
          <a href="#" className="hidden rounded-full bg-white/15 px-4 py-2 text-sm font-medium text-white transition-colors duration-150 hover:bg-white/25 md:block" data-id="element-4957" data-mp="17sizlg57ojk8">
            View All
          </a>
        </div>
      </div>
      <div className="bg-white rounded-b-xl border border-gray-200 border-t-0 p-4 md:p-6" data-id="element-4958" data-mp="12tpuab02vyv5">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-4959" data-mp="1qk1z3d011fhi">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-4960" data-mp="1vj5796bb01tp" />)}
        </div>
      </div>
    </div>;
}